<template>
  <div class="text-left">
    <RejectCommentLayout :comment-text="rejectComment" />
    <v-card class="mt-4 pa-6">
      <v-form ref="form">
        <IndustrialPropertyFields :industrial-property="item" :readonly="readonly" @update="updateField" />
        <v-divider class="mt-6 mb-5" />
        <IndustrialPropertyFiles
          :id="modOp_id"
          :readonly="readonly"
          @save-draft="saveform_trigger = !saveform_trigger"
        />
        <UserFormActions
          v-if="!readonly"
          :form_name_text="$t('forms.titles.' + formName)"
          :form_name="formName"
          :refForm="$refs.form"
          :saveform_trigger="saveform_trigger"
          object_type="industrial_property"
          :data="processData"
          :state="state"
          class="text-center mt-6"
          @change-state="changeState"
        />
        <div v-else class="text-center mt-6">
          <v-btn text @click="$router.go(-1)"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import changeState from "@/mixins/changeState";
import IndustrialPropertyFields from "@/components/industrialProperty/IndustrialPropertyFields.vue";
import IndustrialPropertyFiles from "@/components/industrialProperty/IndustrialPropertyFiles.vue";
import RejectCommentLayout from "@/components/layouts/RejectCommentLayout";
import UserFormActions from "@/components/action_buttons/UserFormActions";
import {
  createDefaultIndustrialProperty,
  normalizeIndustrialProperty,
  serializeIndustrialProperty
} from "@/utils/industrialProperty";

export default {
  name: "IndustrialPropertyFormEditor",
  components: { IndustrialPropertyFields, IndustrialPropertyFiles, RejectCommentLayout, UserFormActions },
  mixins: [changeState],
  props: {
    formName: { type: String, required: true },
    modification: { type: Boolean, default: false }
  },
  data: () => ({
    item: createDefaultIndustrialProperty(),
    modOp_id: null,
    objectId: null,
    state: "",
    rejectComment: "",
    saveform_trigger: false
  }),
  computed: {
    readonly() { return Boolean(this.$route.meta.readOnly); },
    isStoredForm() { return this.$route.params.id > -1 && !this.$route.meta.update; },
    processData() {
      return {
        title: this.item.title || "",
        object_type: "industrial_property",
        form_name: this.formName,
        object_id: this.objectId,
        data: { user: { industrial_property: serializeIndustrialProperty(this.item) } }
      };
    }
  },
  created() {
    if (this.isStoredForm) this.getStoredForm();
    else if (this.modification) this.getItem();
  },
  methods: {
    updateField(field, value) { this.$set(this.item, field, value); },
    getStoredForm() {
      axios.get(`${this.$store.state.endpoint}/user/moderatedOperations/industrial_property/${this.$route.params.id}`)
        .then(response => {
          this.modOp_id = response.data.id;
          this.objectId = response.data.object_id;
          this.item = normalizeIndustrialProperty(response.data.data.user.industrial_property);
          this.state = response.data.state;
          this.rejectComment = response.data.reject_comment || "";
        }).catch(error => console.error(error));
    },
    getItem() {
      axios.get(`${this.$store.state.endpoint}/user/industrial_property/${this.$route.params.id}`)
        .then(response => {
          this.item = normalizeIndustrialProperty(response.data);
          this.objectId = response.data.id;
        }).catch(error => console.error(error));
    }
  }
};
</script>
